import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const PhysicianIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height
    }}
    className="icon icons8-medical-doctor-filled"
  >
    <g id="surface1">
      <path d="M 25 0 C 17.296875 0 15.898438 2.171875 15.65625 2.84375 C 15.628906 2.917969 15.601563 3.015625 15.59375 3.09375 L 14.4375 13.28125 C 15.96875 12.613281 18.066406 12.699219 20.78125 12.84375 C 22.042969 12.910156 23.472656 13 25 13 C 26.523438 13 27.957031 12.910156 29.21875 12.84375 C 31.929688 12.699219 34.03125 12.613281 35.5625 13.28125 L 34.40625 3.09375 C 34.398438 3.015625 34.371094 2.917969 34.34375 2.84375 C 34.101563 2.171875 32.699219 0 25 0 Z M 24 4 L 26 4 L 26 7 L 29 7 L 29 9 L 26 9 L 26 12 L 24 12 L 24 9 L 21 9 L 21 7 L 24 7 Z M 18.65625 14.75 C 16.78125 14.695313 15.34375 14.816406 14.65625 15.46875 C 14.207031 15.898438 14 16.664063 14 17.8125 C 14 23.878906 18.933594 28.8125 25 28.8125 C 31.066406 28.8125 36 23.878906 36 17.8125 C 36 16.664063 35.792969 15.898438 35.34375 15.46875 C 34.429688 14.601563 32.160156 14.695313 29.3125 14.84375 C 28.027344 14.910156 26.578125 15 25 15 C 23.421875 15 21.972656 14.910156 20.6875 14.84375 C 19.976563 14.804688 19.28125 14.769531 18.65625 14.75 Z M 25 29.8125 C 22.757813 29.8125 20.527344 30.015625 18.40625 30.40625 L 25 46.40625 L 31.6875 30.4375 C 29.53125 30.03125 27.28125 29.8125 25 29.8125 Z M 16.4375 30.84375 C 8.300781 32.820313 2 37.347656 2 42.09375 L 2 50 L 25 50 C 24.597656 50 24.214844 49.75 24.0625 49.375 Z M 25 50 L 48 50 L 48 42.09375 C 48 37.371094 41.769531 32.835938 33.6875 30.84375 L 25.9375 49.375 C 25.78125 49.746094 25.402344 50 25 50 Z " />
    </g>
  </IconSvg>
)

export default PhysicianIcon
